@if (authenticateForm() && hash()) {
  <verify-form-page
    [page]="authenticateForm().form"
    [pages]="[authenticateForm().form]"
    [style]="authenticateForm().style"
    [storeId]="[hash(), 'login']"
    [disabledActions]="disabledActions"
    [validationStrategy]="validationStrategy"
    (isValidChanged)="handleIsValidChanged($event)"
    (action)="handleAction($event)"
  ></verify-form-page>
}
